/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, DAKSH_SCREEN, COMMON } from '../../global/Constants';
import { DakshModuleType, DakshSaleType } from '../../global/Enum';
import DesktopFooter from '../common/DesktopFooter';
import Header from '../common/Header';
import Footer from '../common/Footer';
import Loader from '../common/loader/Loader';
import './daksh.css';
import { toast } from 'react-toastify';
import DakshHeader from './components/DakshHeader';
import Utilities from '../../global/Utilities';
import ApiServices from '../../providers/ApiServices';
import SyncLoader from '../common/loader/SyncLoader';

class DakshApproveReject extends Component {

    constructor(props) {
        super(props);
        this.params = "";
        this.state = {
            isLoading: false,
            saleType: DakshSaleType.SEEDWORKS_SALE,
            statusType: 0,
            showButton: true,
            reasons: [],
            selectedReasonId: 0,
            moduleType: DakshModuleType.SALE,
            data: {
                total: 0,
                total_seedworks: 0,
                total_competitor: 0,
                seedworks: [
                    // { id: "1", crop_id: 1, crop_name: "Cotton", hybrid_id: 1, hybrid_name: "US 380", quantity: 100 },
                    // { id: "2", crop_id: 2, crop_name: "Cotton", hybrid_id: 2, hybrid_name: "US 380", quantity: 100 },
                ],
                competitors: [
                    // { id: "1", crop_id: 1, crop_name: "Cotton", hybrid_id: 1, hybrid_name: "US 380", quantity: 100 },
                    // { id: "2", crop_id: 2, crop_name: "Cotton", hybrid_id: 2, hybrid_name: "US 380", quantity: 100 },
                ],
            },
        }
    }

    componentDidMount() {
        if (Utilities.checkLogin()) {
            const data = this.props.location.state.data;
            if (data) {
                Utilities.LogPrint("Data====>", data);
                this.getDakshDataByDakshId(data);
                this.params = data;
                this.setState({
                    moduleType: data.moduleType,
                    statusType: data.statusType,
                    showButton: data.statusType === 0 ? true : false
                });
            }
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    getDakshDataByDakshId = (data) => {
        if (Utilities.isNetworkConnected()) {

            const request = JSON.stringify({
                daksh_id: data.dakshId,
                retailer_id: data.retailerId,
                module_type: data.moduleType
            })

            this.setState({ isLoading: true });
            try {
                ApiServices.getDakshDataByDakshId(request)
                    .then(response => {
                        Utilities.LogPrint("API_DATA: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {
                            const data = response.data;
                            if (data !== null) {
                                this.setState({
                                    data: data
                                });
                            }
                        } else {
                            if (response.message === COMMON.TOKEN_EXPIRED) {
                                Utilities.tokenExpiredRedirectToLogin();
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false });
                    });
            } catch (error) {
                this.setState({ isLoading: false, });
            }

        } else {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
        }
    }

    handleApproveButton = () => {
        if (Utilities.isNetworkConnected()) {

            const request = JSON.stringify({
                retailer_id: this.params.retailerId,
                is_approved: true,
                daksh_id: this.params.dakshId,
            });

            Utilities.LogPrint("Req", request);
            this.setState({ isLoading: true });
            try {
                ApiServices.updateDakshStatus(request)
                    .then(response => {
                        Utilities.LogPrint("UpdateDakshStatus: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {
                            toast.success(response.message);
                            this.props.history.replace(ALL_ROUTES.DAKSH_APPROVAL_ROUTE);
                        } else {
                            alert(response.message);
                            Utilities.LogPrint("Status", response.message);
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false });
                    });
            } catch (error) {
                this.setState({ isLoading: false });
            }
        } else {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
        }
    }

    handleRejectButton = () => {
        if (Utilities.isNetworkConnected()) {

            this.setState({ isLoading: true });
            try {
                ApiServices.getDakshRejectReason("")
                    .then(response => {
                        Utilities.LogPrint("API_DATA: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {
                            const data = response.data;
                            if (data !== null) {
                                const rows = data.rows;
                                let reasons = [];
                                if (rows?.length > 0) {
                                    for (let i = 0; i < rows.length; i++) {
                                        const obj = rows[i];
                                        if (obj.is_active === 1) {
                                            reasons.push(obj);
                                        }
                                    }
                                }
                                this.setState({
                                    reasons: reasons
                                    //reasons: data.rows
                                });
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false });
                    });
            } catch (error) {
                this.setState({ isLoading: false, });
            }

        } else {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
        }
    }

    handleRejectSubmit = () => {
        //const { activity } = this.props;
        const { selectedReasonId, remark } = this.state;

        if (Utilities.isNetworkConnected()) {

            this.setState({ isLoading: true });
            const request = JSON.stringify({
                retailer_id: this.params.retailerId,
                is_approved: false,
                daksh_id: this.params.dakshId,
                daksh_reject_reason_id: selectedReasonId,
                reason: remark,

            });
            Utilities.LogPrint("Req", request);
            try {
                ApiServices.updateDakshStatus(request)
                    .then(response => {
                        Utilities.LogPrint("UpdateDakshStatus: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {
                            toast.success(response.message);
                            this.props.history.replace(ALL_ROUTES.DAKSH_APPROVAL_ROUTE);
                        } else {
                            alert(response.message);
                            Utilities.LogPrint("Status", response.message);
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false });
                    });
            } catch (error) {
                this.setState({ isLoading: false });
            }
        } else {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
        }
    }

    handleOnChange(e) {
        Utilities.LogPrint('Selected Reason', e.target.value);
        this.setState({ selectedReasonId: parseInt(e.target.value) });
    }

    changeHandler = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    isValid() {
        const { selectedReasonId } = this.state;
        return selectedReasonId === 0;
    }

    handleModeType = (type) => {
        const { moduleType, data, statusType } = this.state;
        data.statusType = statusType;

        switch (type) {
            case DakshSaleType.SEEDWORKS_SALE:
                this.props.history.push({
                    pathname: ALL_ROUTES.DAKSH_DETAILS_ROUTE,
                    state: { moduleType: moduleType, data: data, saleType: DakshSaleType.SEEDWORKS_SALE }
                });
                break;
            case DakshSaleType.COMPETITOR_SALE:
                this.props.history.push({
                    pathname: ALL_ROUTES.DAKSH_DETAILS_ROUTE,
                    state: { moduleType: moduleType, data: data, saleType: DakshSaleType.COMPETITOR_SALE }
                });
                break;

            default:
                break;
        }
    }

    setTitleStatus = (status) => {
        return (
            <h5 className="font mt-0">{this.setModuleType()}
                <i className={
                    status === 2 ? "customic ic-sale-red" :
                        status === 0 ? "customic ic-sale-yellow" :
                            status === 1 ? "customic ic-sale-green" : "d-none"
                }></i>
                {/* <i className="customic ic-sale-green"></i> */}
                {/* <i class="customic ic-sale-yellow"></i> */}
                {/* <i class="customic ic-sale-red"></i> */}
            </h5>
        )
    }


    setModuleType = () => {
        const { moduleType } = this.state;
        switch (parseInt(moduleType)) {
            case 1:
                return DAKSH_SCREEN.SALE;
            case 2:
                return DAKSH_SCREEN.PLAN;
            default:
                break;
        }
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName);
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isLoading, data, statusType, showButton, reasons } = this.state;
        const { isSyncLoading, tableName } = this.state;
        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />
                <Footer />

                <div className="container pt-35 daksh">
                    <DakshHeader />

                    <div className="row">
                        <div className="col-12 sale-table">
                            {/* <h5 className="font mt-2 mt-md-4">Sale</h5> */}
                            {/* <TitleStatus
                                title={this.setModuleType()}
                                status={DakshStatus.COMPLETED}
                            /> */}
                            {this.setTitleStatus(statusType)}
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th width="60%"></th>
                                            <th width="40%">Quantity</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td><b>Total</b></td>
                                            <td><b>{data.total}</b></td>
                                        </tr>
                                        <tr className="cursor-pointer" onClick={() => this.handleModeType(1)}>
                                            <td><u>Seedworks Sale</u></td>
                                            <td><b>{data.total_seedworks}</b></td>
                                        </tr>
                                        <tr className="cursor-pointer" onClick={() => this.handleModeType(2)}>
                                            <td><u>Competitor Sale</u></td>
                                            <td><b>{data.total_competitor}</b></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {showButton ?
                            <div className="col-12 mt-4 mb-4 btn-group-w">
                                <button className="btn btn-secondary w-182" onClick={this.handleApproveButton}>{COMMON.APPROVE}</button>
                                <button className="btn btn-secondary ml-3 w-182" data-toggle="modal" data-target="#rejectReasonPopup" onClick={this.handleRejectButton}>{COMMON.REJECT}</button>
                            </div> : null
                        }

                    </div>
                </div>
                <DesktopFooter />
                {isLoading ? <Loader /> : null}
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}

                {/* Reject Reason Popup */}
                {this.showRejectPopup(reasons)}

            </div>
        )
    }

    showRejectPopup = (reasons) => {
        const { remark } = this.state;
        return (
            <div className="modal fade bottom-drawer reject-reason-popup" id="rejectReasonPopup" role="dialog" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h6 className="font-weight-medium">Select The Reason</h6>
                            <div className="form-group">

                                {
                                    reasons?.length ?
                                        reasons?.map(item => (
                                            <label className="custom-radio-container mt-3" key={item.daksh_reject_reason_id}>
                                                {item.reject_reason}
                                                <input type="radio" name="radio" value={item.daksh_reject_reason_id} onChange={(e) => this.handleOnChange(e)} />
                                                <span className="checkmark"></span>
                                            </label>
                                        )) : null
                                }

                            </div>
                            <div className="form-group"><label className="font-weight-medium">{COMMON.REMARKS}</label>
                                <textarea className="form-control" rows="3" name="remark"
                                    value={remark} onChange={this.changeHandler}></textarea>
                            </div>
                            <button className="btn btn-secondary w-50 float-right" data-dismiss="modal"
                                onClick={this.handleRejectSubmit}
                                disabled={this.isValid()}>{COMMON.SUBMIT}</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(DakshApproveReject);